import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


export const FEATURES_ROUTES: Routes = [
    { path: 'home', loadChildren: '@app/features/home/home.module#HomeModule' },
    { path: 'login', loadChildren: '@app/features/login/login.module#LoginModule' },
    { path: 'form', loadChildren: '@app/features/form/form.module#FormModule' },
    { path: 'request-list', loadChildren: '@app/features/request-list/request-list.module#RequestListModule' },
    { path: 'forbidden', loadChildren: '@app/features/forbidden/forbidden.module#ForbiddenModule' }
];


const MODULES: any[] = [
];


@NgModule({
  imports: [
    ...MODULES,
    RouterModule.forChild(FEATURES_ROUTES)
  ],
  exports: MODULES
})
export class FeaturesModule {}
